webpackJsonp([202188200683061],{

/***/ 845:
/***/ (function(module, exports) {

	module.exports = {"data":{"contributionsJson":{"name":"bond girl","www_url":"http://www.r23.ch","thema":"006","issue_month":"May","issue_year":2006,"issue_date":200605,"artist":"linda","location":"Switzerland","email":"ruth@i-love-u.ch","id":"contribution_202","media_type":"still_image","position_in_section":7,"media_uri":"media/2006/May/still_image/bond003.jpg","media_th_uri":"media/2006/May/still_image/tn_bond003.jpg","still_image_count":9,"moving_image_count":2,"textz_count":1,"soundz_count":0}},"pathContext":{"id":"contribution_202"}}

/***/ })

});


// WEBPACK FOOTER //
// path---issue-200605-still-image-7-7db4725ca9d79fe07040.js